'use client';

import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import displayModeStore from '@/stores/displayModeStore';
import { useBamboo } from '@/hooks/useBamboo';

const BambooCanvas = observer(() => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Hydrate display mode from localStorage after mount (SSR-safe)
  useEffect(() => {
    displayModeStore.hydrate();
  }, []);

  useBamboo(containerRef);

  const showBamboo = displayModeStore.showBamboo;
  const isSplit = displayModeStore.isSplit;

  return (
    <div
      ref={containerRef}
      className="fixed inset-0 z-40"
      style={{
        bottom: '64px',
        // Split mode: bamboo takes bottom half; full bamboo: top 0
        top: isSplit ? '50%' : '0',
        visibility: showBamboo ? 'visible' : 'hidden',
        pointerEvents: showBamboo ? 'auto' : 'none',
      }}
    />
  );
});

export default BambooCanvas;
